var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5521",
    "data-name": "Group 5521",
    transform: "translate(-1192.5 -245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1960",
    "data-name": "Rectangle 1960",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1192.5 245)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    "data-name": "Path 3312",
    d: "M77.561,30.58a1.962,1.962,0,0,0-1.4-.58h-.876v.879a1.759,1.759,0,0,1-1.756,1.758h-7.9a1.759,1.759,0,0,1-1.756-1.758V30h-.879a1.979,1.979,0,0,0-1.975,1.975L61,49.2a1.976,1.976,0,0,0,1.975,1.98H76.144a1.979,1.979,0,0,0,1.975-1.975l.019-17.227A1.966,1.966,0,0,0,77.561,30.58Zm-7.768,6.012h4.678a.659.659,0,0,1,0,1.318H69.793a.659.659,0,0,1,0-1.318Zm0,4.395h4.678a.659.659,0,0,1,0,1.318H69.793a.659.659,0,0,1,0-1.318Zm0,4.395h4.7a.659.659,0,0,1,0,1.318h-4.7a.659.659,0,0,1,0-1.318Zm-5.61-8.763a.658.658,0,0,1,.931,0l.358.358,1.518-1.52a.659.659,0,0,1,.931.932l-1.984,1.986a.658.658,0,0,1-.931,0l-.824-.825A.66.66,0,0,1,64.183,36.618Zm0,4.73a.658.658,0,0,1,.931,0l.358.358,1.518-1.52a.659.659,0,0,1,.931.932L65.938,43.1a.658.658,0,0,1-.931,0l-.824-.825A.66.66,0,0,1,64.183,41.348Zm0,4.395a.658.658,0,0,1,.931,0l.358.358,1.518-1.52a.659.659,0,0,1,.931.932L65.938,47.5a.658.658,0,0,1-.931,0l-.824-.825A.66.66,0,0,1,64.183,45.742Z",
    transform: "translate(1147.931 230.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3313",
    "data-name": "Path 3313",
    d: "M156.361,2.2a.439.439,0,0,0,.439.439h7.9a.439.439,0,0,0,.439-.439V.439A.439.439,0,0,0,164.7,0h-7.9a.439.439,0,0,0-.439.439Z",
    transform: "translate(1056.761 258.75)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyService);
export default __webpack_public_path__ + "static/media/myService.1adad2909169451e7f890e83a7fab9c6.svg";
export { ForwardRef as ReactComponent };